import { render, staticRenderFns } from "./conversation-chips.vue?vue&type=template&id=4cbd8bb0&scoped=true&"
import script from "./conversation-chips.vue?vue&type=script&lang=js&"
export * from "./conversation-chips.vue?vue&type=script&lang=js&"
import style0 from "./conversation-chips.vue?vue&type=style&index=0&id=4cbd8bb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd8bb0",
  null
  
)

export default component.exports